<template>
  <div class="min-h-100  w-100 d-flex flex-column">
    <div class="atm-dekstop-max-width bg-plain pb-4 main h-100 w-100">
      <b-skeleton-wrapper :loading="loading">
        <template #loading>
          <parent-child-home-data-skeleton :theme="theme"></parent-child-home-data-skeleton>
        </template>
        <parent-child-home-data
          :class="theme"
          :userIsAParent="true"
          :userName="sessionStore.userName"
          :levelInfo="levelInfo"
          :coinsInfo="coinsInfo"
          :childrenData="childrenData"
          :childSelectedId="childSelectedId"
          @onChildSelectedChange="changeChildSelection"
        ></parent-child-home-data>
        <div class="mainComponents mx-auto pb-2 my-4">
          <div style="margin-top: -59px;">
            <home-main-actions :action="mainActions" :coinsInfo="coinsInfo"></home-main-actions>
          </div>
          <home-main-tasks
            :tasks="tasksToBeDisplayed"
            :haveTask="todayTasks && !!todayTasks.length"
          ></home-main-tasks>
          <div class="mx-auto">
            <home-second-actions :action="secondActions"></home-second-actions>
          </div>
        </div>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import { persisteChildSelection } from '@/auth';
import { fetchTodayTasks } from '@/tasks';
import { getRankingAndLevelInformation, getCoinsInformation } from '@/gamification';
import { useSessionStore } from '@/common';
import { getThemeColor } from '@/common/utils';

import { HomeMainActions, HomeMainTasks, HomeSecondActions } from '@/common/components/home';
import ParentChildHomeData from './ParentChildHomeData';
import ParentChildHomeDataSkeleton from '@/common/components/parent/skeletons/ParentChildHomeDataSkeleton';

export default {
  name: 'parentMain',
  components: {
    ParentChildHomeData,
    HomeMainTasks,
    HomeMainActions,
    HomeSecondActions,
    ParentChildHomeDataSkeleton,
  },
  data: function() {
    const sessionStore = useSessionStore();
    return {
      loading: true,
      sessionStore,
      todayTasks: [],
      levelInfo: {},
      coinsInfo: {},
      childrenData: [],
      childSelectedId: '',
      mainActions: [
        {
          title: 'Coins to Approve',
          img: require('@/assets/coin2.svg'),
          class: 'text-warning font-weight-bold',
          router: '/allow-coins',
          enable: true,
        },
        {
          title: 'Checklists',
          img: require('@/assets/icons/icon-checklist.svg'),
          class: 'text-blue-dark font-weight-bold',
          router: '/checklist',
          enable: true,
        },
      ],
      secondActions: [
        {
          title: 'Rewards',
          img: require('@/assets/icons/icon-gift.svg'),
          router: '/rewards',
          text: 'card_giftcard',
          enable: true,
        },
        {
          title: 'Progress',
          img: require('@/assets/icons/icon-progress.svg'),
          router: '/progress',
          text: 'insights',
          enable: true,
        },
        {
          title: 'Rate',
          img: require('@/assets/Rate.svg'),
          router: '/rate',
          text: 'emoji_events',
          enable: true,
        },
      ],
    };
  },
  computed: {
    theme() {
      return `bg-${getThemeColor(this.sessionStore.themeSelection)}`;
    },
    tasksToBeDisplayed() {
      return this.todayTasks.slice(0, 5);
    },
  },
  methods: {
    changeChildSelection({ childId }) {
      persisteChildSelection(childId);
      this.loadChildInformation(childId.toString());
    },
    async loadChildInformation(childId) {
      this.loading = true;
      this.childSelectedId = childId;
      let requestsData = await Promise.all([
        fetchTodayTasks(childId),
        getRankingAndLevelInformation(childId),
        getCoinsInformation(childId),
      ]);
      let taskData = requestsData[0];
      let rankingInfo = requestsData[1];
      let coinsInfo = requestsData[2];
      this.todayTasks = taskData;
      this.levelInfo = {
        name: rankingInfo.userLevel.name,
        score: rankingInfo.userPoints,
      };
      this.coinsInfo = {
        banked: coinsInfo.Banked,
        Pending: coinsInfo.Pending,
      };
      this.loading = false;
    },
  },
  async mounted() {
    let childId = `${this.sessionStore.childSelectedId}`;
    this.childrenData = this.sessionStore.children;
    if (childId) await this.loadChildInformation(childId);
  },
};
</script>

<style lang="scss" scoped>
.mainComponents {
  width: 95%;
  max-width: 1000px;
  padding: 0 2rem;
  margin: 0;
}
</style>
